import React from "react";

import { Funnel, Zap } from "lucide-react";

interface ItableContent {
    title: string;
    description: string;
    division: string;
    type: string;
    priority: 'critical' | 'high' | 'medium' | 'low';
    status: "completed" | "processing" | "pending";
};
export const RecommendedActions = () => {

    const tableContents: ItableContent[] = [
        {
            title: 'Dynamic Lead-Phish Banner',
            description: "Deploying high-contrast External Lead' banners in Outlook for all incoming non-CRM mail to counteract end-of-quarter impulsivity.",
            division: 'Sales',
            type: 'Email Warning',
            priority: 'high',
            status: 'processing',
        },
        {
            title: 'Micro-Training: The Speed Trap',
            description: '60-second interactive module on the Pause Reflect Exercise',
            division: 'Sales',
            type: 'Training',
            priority: 'medium',
            status: 'completed',
        },
        {
            title: 'Static URL Sandboxing',
            description: 'Enforcing aggressive browser isolation for URLs clicked within 5 seconds of email delivery',
            division: 'Sales',
            type: 'Security Control',
            priority: 'high',
            status: 'pending',
        },
        {
            title: 'Mandatory 2nd-Path Verification',
            description: 'Forcing out-of-band (Voice/Teams) verification for any invoice change during high-load periods (Tax/Audit season).',
            division: 'Finance',
            type: 'Policy Control',
            priority: 'critical',
            status: 'completed',
        },
        {
            title: 'Authority-Spoof Simulation',
            description: 'Simulating a high-pressure request from the CFO to test resilience during peak cognitive load.',
            division: 'Finance',
            type: 'Phish Sim Training',
            priority: 'high',
            status: 'processing',
        },
        {
            title: 'Secure AI Sandbox Deployment',
            description: 'Providing a vetted LLM environment to prevent "Shortcut behaviors where proprietary code is leaked to public Al.',
            division: 'Engineering',
            type: 'Security Control',
            priority: 'high',
            status: 'processing',
        },
        {
            title: 'Shadow IT Scanning (CASB)',
            description: 'Automated scan for unvetted AI tools used as shortcuts to bypass official project management software.',
            division: 'Engineering',
            type: 'Security Control',
            priority: 'medium',
            status: 'pending',
        },
        {
            title: 'Peer Workshop',
            description: "Peer-led session on 'Security for Experts' to address the bias that tech-savviness equals invulnerability.",
            division: 'Engineering',
            type: 'Training',
            priority: 'low',
            status: 'completed',
        },
    ];

    return (
        <div className='card card--md card--radius-md card--hover-shadow dashboard__mcsa__recommended_actions'>
            <div className='d-flex justify-content-between align-items-center mb-xl'>
                <div>
                    <p className='text-lg text-semibold'>Recommended Actions</p>
                    <p className='text-sm color--txt-muted'>Targeted interventions based on cognitive risk detection</p>
                </div>
                <button className='btn btn--sm btn--radius-sm btn--secondary'>
                    <Funnel />
                    <span>Filter</span>
                </button>
            </div>
            <table className='dashboard__mcsa__recommended_actions__table'>
                <thead>
                    <tr>
                        <th><p className='text-sm text-medium color--txt-muted text-left'>Title</p></th>
                        <th><p className='text-sm text-medium color--txt-muted text-left'>Division</p></th>
                        <th><p className='text-sm text-medium color--txt-muted text-left'>Type</p></th>
                        <th><p className='text-sm text-medium color--txt-muted text-left'>Priority</p></th>
                        <th><p className='text-sm text-medium color--txt-muted text-left'>Status</p></th>
                        <th><p className='text-sm text-medium color--txt-muted text-left'>Actions</p></th>
                    </tr>
                </thead>
                <tbody>
                    {tableContents.map(content => (
                        <tr key={content.title}>
                            <td>
                                <div>
                                    <p className="text-sm text-semibold">{content.title}</p>
                                    <p className="text-sm color--txt-muted mt-xs">{content.description}</p>
                                </div>
                            </td>
                            <td>
                                <p className='text-sm color--txt-muted'>{content.division}</p>
                            </td>
                            <td>
                                <p className='text-sm color--txt-muted'>{content.type}</p>
                            </td>
                            <td>
                                <div className={`dashboard__mcsa__recommended_actions__table__cell__priority dashboard__mcsa__recommended_actions__table__cell__priority--${content.priority}`}>
                                    <div>{content.priority}</div>
                                </div>
                            </td>
                            <td>
                                <div className={`dashboard__mcsa__recommended_actions__table__cell__status dashboard__mcsa__recommended_actions__table__cell__status--${content.status}`}>
                                    <div>{content.status[0].toUpperCase() + content.status.slice(1)}</div>
                                </div>
                            </td>
                            <td>
                                <div className='d-flex gap-sm'>
                                    <button className='btn btn--icon-sm btn--radius-sm btn--secondary'>
                                        <Zap className='color--txt-muted' />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};